import {
  CODE_DOWNLOAD_FILENAME_BASE,
  DEFAULT_CODE_EXTENSION,
  DOCKERFILE_FILENAME,
  DOCKERFILE_LANGUAGE_ID,
} from './cmarkdowncodeConstants';

const PLAIN_TEXT_DISPLAY_NAME = 'Plain Text';

const LANGUAGE_DISPLAY_NAME_MAP: Record<string, string> = {
  javascript: 'JavaScript',
  js: 'JavaScript',
  typescript: 'TypeScript',
  ts: 'TypeScript',
  jsx: 'JSX',
  tsx: 'TSX',
  python: 'Python',
  py: 'Python',
  ruby: 'Ruby',
  rb: 'Ruby',
  go: 'Go',
  golang: 'Go',
  rust: 'Rust',
  rs: 'Rust',
  java: 'Java',
  c: 'C',
  cpp: 'C++',
  'c++': 'C++',
  cxx: 'C++',
  csharp: 'C#',
  'c#': 'C#',
  cs: 'C#',
  php: 'PHP',
  swift: 'Swift',
  kotlin: 'Kotlin',
  kt: 'Kotlin',
  scala: 'Scala',
  shell: 'Shell',
  bash: 'Shell',
  sh: 'Shell',
  zsh: 'Shell',
  powershell: 'PowerShell',
  ps: 'PowerShell',
  ps1: 'PowerShell',
  sql: 'SQL',
  html: 'HTML',
  css: 'CSS',
  scss: 'SCSS',
  sass: 'Sass',
  less: 'Less',
  json: 'JSON',
  yaml: 'YAML',
  yml: 'YAML',
  xml: 'XML',
  markdown: 'Markdown',
  md: 'Markdown',
  toml: 'TOML',
  ini: 'INI',
  diff: 'Diff',
  patch: 'Diff',
  dockerfile: 'Dockerfile',
  text: PLAIN_TEXT_DISPLAY_NAME,
  plain: PLAIN_TEXT_DISPLAY_NAME,
  plaintext: PLAIN_TEXT_DISPLAY_NAME,
  txt: PLAIN_TEXT_DISPLAY_NAME,
};

const LANGUAGE_EXTENSION_MAP: Record<string, string> = {
  javascript: 'js',
  js: 'js',
  typescript: 'ts',
  ts: 'ts',
  jsx: 'jsx',
  tsx: 'tsx',
  python: 'py',
  py: 'py',
  ruby: 'rb',
  rb: 'rb',
  go: 'go',
  golang: 'go',
  rust: 'rs',
  rs: 'rs',
  java: 'java',
  c: 'c',
  cpp: 'cpp',
  'c++': 'cpp',
  cxx: 'cpp',
  csharp: 'cs',
  'c#': 'cs',
  cs: 'cs',
  php: 'php',
  swift: 'swift',
  kotlin: 'kt',
  kt: 'kt',
  scala: 'scala',
  shell: 'sh',
  bash: 'sh',
  sh: 'sh',
  zsh: 'sh',
  powershell: 'ps1',
  ps: 'ps1',
  ps1: 'ps1',
  sql: 'sql',
  html: 'html',
  css: 'css',
  scss: 'scss',
  sass: 'sass',
  less: 'less',
  json: 'json',
  yaml: 'yml',
  yml: 'yml',
  xml: 'xml',
  markdown: 'md',
  md: 'md',
  toml: 'toml',
  ini: 'ini',
  diff: 'diff',
  patch: 'diff',
  text: 'txt',
  plain: 'txt',
  plaintext: 'txt',
};

function normalizeLanguage(language: string | undefined): string | undefined {
  return language?.toLowerCase().trim();
}

export function resolveDisplayName(language: string | undefined): string {
  const normalizedLanguage = normalizeLanguage(language);
  if (!normalizedLanguage) return PLAIN_TEXT_DISPLAY_NAME;
  return LANGUAGE_DISPLAY_NAME_MAP[normalizedLanguage] ?? PLAIN_TEXT_DISPLAY_NAME;
}

export function resolveDownloadFilename(language: string | undefined): string {
  const normalizedLanguage = normalizeLanguage(language);
  if (normalizedLanguage === DOCKERFILE_LANGUAGE_ID) {
    return DOCKERFILE_FILENAME;
  }

  const extension = (normalizedLanguage && LANGUAGE_EXTENSION_MAP[normalizedLanguage]) || DEFAULT_CODE_EXTENSION;
  return `${CODE_DOWNLOAD_FILENAME_BASE}.${extension}`;
}
